import React, { Component } from 'react';

class NotFound extends Component {
    render() {
        return (
            <div className="main">
                <div className="page">
                    <h2>404 Sidan hittade inte</h2>
                    <p>Vi kunde inte hitta sidan du letade efter.</p>
                </div>
            </div>
        );
    }
}

export default NotFound;


// WEBPACK FOOTER //
// ./src/components/error/NotFound.js